import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import { storeInstance } from './store';
import { sync } from 'vuex-router-sync';
import Vuelidate from 'vuelidate';
import './styles/quasar.styl';
import 'quasar/dist/quasar.ie.polyfills';
import lang from 'quasar/lang/es.js';
import '@quasar/extras/roboto-font/roboto-font.css';
import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';
import './assets/css/generales.scss';
import filters from './filters.js';
import * as AuthService from '@/services/AuthService.js';

import {
  Quasar,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QCard,
  QCardSection,
  QCardActions,
  QDate,
  QInput,
  Ripple,
  QCheckbox,
  Notify,
  QChip,
  QExpansionItem,
  QSelect,
  QSeparator,
  ClosePopup,
  QBadge,
  QLinearProgress,
  Cookies,
  SessionStorage,
  Loading,
  QTooltip,
  QFile
} from 'quasar';

Vue.use(Quasar, {
  config: {},
  components: {
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QCard,
    QCardSection,
    QCardActions,
    QDate,
    QInput,
    QCheckbox,
    QChip,
    QExpansionItem,
    QSelect,
    QSeparator,
    QBadge,
    QLinearProgress,
    QTooltip,
    QFile
  },
  directives: {
    ClosePopup,
    Ripple
  },
  plugins: {
    Cookies,
    Notify,
    SessionStorage,
    Loading
  },
  lang: lang
});

Vue.use(Vuelidate);
Vue.config.productionTip = false;
filters.create(Vue);

const GlobalEventBus = new Vue();
Vue.prototype.$eventHub = GlobalEventBus;

sync(storeInstance, router);

Vue.config.productionTip = false;

const isMunicipioMode = typeof window !== 'undefined' && window.location && window.location.href.indexOf('IdMunicipio') !== -1;

if (isMunicipioMode) {
  try {
    const url = new URL(window.location.href);
    const idMunicipio = url.searchParams.get('IdMunicipio');
    if (idMunicipio) {
      storeInstance.commit('NGUD/setPublicMode', true);
      storeInstance.commit('NGUD/setIdMunicipio', idMunicipio);
    }
  } catch (e) {
    console.warn('No se pudo parsear IdMunicipio desde la URL', e);
  }
  new Vue({
    store: storeInstance,
    router,
    render: h => h(App)
  }).$mount('#app');
} else {
  storeInstance.commit('NGUD/setPublicMode', false);
  storeInstance.commit('NGUD/setIdMunicipio', null);
  // Lanzamos la inicializacion del OpenID
  AuthService.init().then(d => {
    if (d) {
      new Vue({
        store: storeInstance,
        router,
        render: h => h(App)
      }).$mount('#app');
    }
  }).catch(e => {
    console.log(e);
  });
}
